import hackerPortrait from '@/assets/characters/hacker.jpg'
import instructorPortrait from '@/assets/characters/instructor.jpg'
import medicPortrait from '@/assets/characters/medic.jpg'
import playerPortrait from '@/assets/characters/player.jpg'

export default {

  instructor: {
    // age: 32,
    firstName: 'Mikhail',
    lastName: 'Largatsov',
    portrait: instructorPortrait
  },

  player: {
    // age: 52,
    firstName: 'Johan',
    lastName: 'Mett',
    portrait: playerPortrait
  },

  medic: {
    // age: 27,
    firstName: 'Lea',
    lastName: 'Ivanova',
    portrait: medicPortrait
  },

  hacker: {
    // age: 24,
    firstName: 'Kandar',
    lastName: 'Mett',
    portrait: hackerPortrait
  }

}
